// A1-105 (review 2026-11-01): the review screen loaded only the first 50 rows
// of each card and offered no way to the rest. A card fetches its own next
// page (review-grouped?flag_type=...&page=N); these rows, and every per-row
// list the server sends with them (which are answered, which are re-invoiced
// or amendable exchange rows), are added to that card, so every rule that
// reads them (which card asks a question, ticking, the canonical card of a
// shared row, Keep) sees them as the server does.
export const ROWS_PAGE = 50;   // the page size the review screen asks for

const ROW_LISTS = ["acknowledged_txn_ids", "reinvoiced_fx_txn_ids", "amendable_fx_txn_ids"];

// One card's extra pages: the pages fetched (page 1 is the reply itself) and
// their content, each list free of repeats.
export const addPage = (had, next, pageNo) => {
  const prev = had || { pages: 1, rows: [], txn_ids: [] };
  // a page already held (fetched twice: a click while pages are reloaded) adds nothing
  if (pageNo && pageNo <= prev.pages) return prev;
  const fresh = (seen) => (id) => (seen.has(id) ? false : (seen.add(id), true));
  const newId = fresh(new Set(prev.txn_ids));
  const newRow = fresh(new Set(prev.rows.map((r) => r.txn_id)));
  const out = {
    ...prev,
    pages: pageNo || prev.pages + 1,
    rows: prev.rows.concat((next.rows || []).filter((r) => newRow(r.txn_id))),
    txn_ids: prev.txn_ids.concat((next.txn_ids || []).filter(newId)),
  };
  ROW_LISTS.forEach((k) => { out[k] = [...new Set([...(prev[k] || []), ...(next[k] || [])])]; });
  return out;
};

export const withMoreRows = (data, byFlag) => {
  if (!data || !byFlag || !Object.keys(byFlag).length) return data;
  return {
    ...data,
    groups: (data.groups || []).map((g) => {
      const extra = byFlag[g.flag_type];
      if (!extra) return g;
      const ids = new Set(g.txn_ids || []);
      const rowIds = new Set((g.rows || []).map((r) => r.txn_id));
      const merged = {
        ...g,
        rows: (g.rows || []).concat((extra.rows || []).filter((r) => !rowIds.has(r.txn_id))),
        txn_ids: (g.txn_ids || []).concat((extra.txn_ids || []).filter((id) => !ids.has(id))),
      };
      ROW_LISTS.forEach((k) => {
        if (g[k] !== undefined || extra[k]) merged[k] = [...new Set([...(g[k] || []), ...(extra[k] || [])])];
      });
      return merged;
    }),
  };
};
